module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Boiler",
      "name": "boiler"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Boiler Pressure: " + _vm._s(_vm.boilerForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.boilerForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.boilerForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "enabled", $$v)
      },
      expression: "boilerForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "calibrationAdjustment", $$v)
      },
      expression: "boilerForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "rangeHigh", $$v)
      },
      expression: "boilerForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boilerForm.enabled),
      expression: "boilerForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.boilerForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.boilerForm, "rangeLow", $$v)
      },
      expression: "boilerForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Supply",
      "name": "supply"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Supply Pressure: " + _vm._s(_vm.supplyForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.supplyForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.supplyForm.allowControlEnabled
    },
    model: {
      value: (_vm.supplyForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "enabled", $$v)
      },
      expression: "supplyForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "calibrationAdjustment", $$v)
      },
      expression: "supplyForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "rangeHigh", $$v)
      },
      expression: "supplyForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supplyForm.enabled),
      expression: "supplyForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.supplyForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.supplyForm, "rangeLow", $$v)
      },
      expression: "supplyForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Return",
      "name": "return"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('h2', [_vm._v("Return Pressure: " + _vm._s(_vm.returnForm.currentPressure))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.returnForm,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Enabled"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.returnForm.allowControlEnabled
    },
    model: {
      value: (_vm.returnForm.enabled),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "enabled", $$v)
      },
      expression: "returnForm.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Calibration Adjustment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.calibrationAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "calibrationAdjustment", $$v)
      },
      expression: "returnForm.calibrationAdjustment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Range High (20mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.rangeHigh),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "rangeHigh", $$v)
      },
      expression: "returnForm.rangeHigh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.enabled),
      expression: "returnForm.enabled"
    }],
    attrs: {
      "label": "Range Low (4mA)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.returnForm.rangeLow),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "rangeLow", $$v)
      },
      expression: "returnForm.rangeLow"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ac31e07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/PressureSensors.vue
// module id = 1381
// module chunks = 1